import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('fullwidth-slider', {
    data() {
        return {
            tabIndex: 0,
            sectionIndex: 0,
        };
    },

    async mounted() {
        await this.initSwiper();
    },

    methods: {
        switchSection(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                this.sectionIndex = index;

                setTimeout(() => this.initSwiper(), 100);
            }
        },

        async initSwiper() {
            const { Swiper } = await getSwiper();
            const { Pagination } = await getSwiperModules();

            new Swiper('.fullwidth-slider__slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                centeredSlides: true,
                modules: [Pagination],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: (index, className) =>
                        `<span class='${className}'><span></span></span>`,
                },
                uniqueNavElements: true,
                navigation: {
                    nextEl: '.page-slider-next',
                    prevEl: '.page-slider-prev',
                },
            });
        },
    },
});
